import { render, staticRenderFns } from "./StockManager.vue?vue&type=template&id=c6c71202&scoped=true&"
import script from "./StockManager.vue?vue&type=script&lang=js&"
export * from "./StockManager.vue?vue&type=script&lang=js&"
import style0 from "./StockManager.vue?vue&type=style&index=0&id=c6c71202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c71202",
  null
  
)

export default component.exports